import React from 'react'
import styled from 'styled-components'

import Card from 'pages/HehmDevice/HehmDashboard/Card'

import { DeviceBase } from 'types/Device'

type Props = {
  device: DeviceBase
  onNavigate: (tab: string) => void
}

const AlertCard = ({ device, onNavigate }: Props) => {
  const alerts = [
    {
      count: device.sdaCriticalAlertCount,
      label: 'Critical SDAs',
      img: '/img/critical_sda_alert.svg',
      imgAlt: 'SDA Critical Icon'
    },
    {
      count: device.sdaMajorAlertCount,
      label: 'Major SDAs',
      img: '/img/major_sda_alert.svg',
      imgAlt: 'Major SDA Icon'
    },
    {
      count: device.sdaMinorAlertCount,
      label: 'Minor SDAs',
      img: '/img/minor_sda_alert.svg',
      imgAlt: 'Minor SDA Icon'
    }
  ]

  return (
    <S.Card
      title="Alerts"
      icon="/img/alert-status-none.svg"
      onClick={() => onNavigate('alerts')}
    >
      {alerts.map(
        ({ count, label, img, imgAlt }) =>
          count > 0 && (
            <S.AlertCount key={label}>
              <S.Img
                src={img}
                alt={imgAlt}
              />
              {count} {label}
            </S.AlertCount>
          )
      )}
    </S.Card>
  )
}

export default AlertCard

const S = {
  Img: styled.img`
    width: 32px;
    height: 32px;
    margin-top: -5px;
  `,
  Card: styled(Card)`
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: min-content;
  `,
  AlertCount: styled.span`
    display: inline-flex;
    align-items: center;
    gap: 5px;
  `
}
